module.exports = __webpack_public_path__ + "static/media/35.8b432eef.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/35.png
// module id = 403
// module chunks = 0